import React from "react";
import PropTypes from "prop-types";
import UsersTableContainerNew from "../users/users-table-container/UsersTableContainerNew";
import GroupsTableContainerNew from "../groups/groups-table-container/GroupsTableContainerNew";
import LogsTableContainer from "../log-activity/logs-table-container/LogsTableContainer";
import RolesTableContainerNew from "../roles/roles-table-container-new/RolesTableContainerNew";
import TemplateTableContainerNew from "../templates/templates-table-container/TemplateTableContainerNew";
import AdminRolePrivilegePage from "../admin-role-privilege-page/admin-role-privilege-page";
import AdminEmailConfigPage from "../admin-email-config-page/admin-email-config-page";
import NoPermissionTable from "../../../../components/no-permission-table/NoPermissionTable";
import TaskTypesTable from "../task-types/task-types-table/task-types-table";
import SettingsEditor from "../super-admin-settings-editor/super-admin-settings-editor";
import Workflow from "../workflow/workflow-table";
import OrganizationMain from "../../../admin/scenes/organization/OrganizationMain.jsx";
import { FixRolePrivileges } from "../../../../services/api/role-privilege-api";
import { selectUser } from "../../../../redux/user/user-selector";
import { useSelector } from "react-redux";
import FieldRepositoryTable from "../field-repository/field-repository-table";
import "./admin-main-table.styles.scss";

const AdminMainTable = ({ currentTab, currentSubTab = "" }) => {
  const user = useSelector(selectUser);
  const { privileges, profile } = user;

  const componentMap = {
    Users: {
      component: UsersTableContainerNew,
      permission: "User"
    },
    Groups: {
      component: GroupsTableContainerNew,
      permission: "Group",
    },
    "Log Activity": {
      component: LogsTableContainer,
      permission: "Log Activity",
    },
    Roles: {
      component: RolesTableContainerNew,
      permission: "Role",
    },
    Organization: {
      component: OrganizationMain,
      permission: "Department",
      extraProps: { currentSubTab },
    },
    "Role Privileges": {
      component: AdminRolePrivilegePage,
      permission: "Role Privileges",
    },
    Templates: {
      component: TemplateTableContainerNew,
      permission: "Templates",
    },
    "Task Types": {
      component: TaskTypesTable,
      permission: "Task Types"
    },
    "Settings Editor": {
      component: SettingsEditor,
      permission: "Settings Editor",
    },
    Workflow: {
      component: Workflow,
      permission: "Workflow",
    },
    "Field Repository": {
      component: FieldRepositoryTable,
      permission: "Field Repository",
    },
    Notifications: {
      component: AdminEmailConfigPage,
      permission: "Notifications",
      emailPermission: "Email Notifications",
      platformPermission: "Platform Notifications",
    },
  };

  const {
    component: Component,
    permission,
    emailPermission,
    platformPermission,
    condition,
    extraProps,
  } = componentMap[currentTab] || {};

  const hasPermission =
  (currentTab === "Organization" &&
    (privileges["Department"]?.View || privileges["Sub-Department"]?.View)) ||
  privileges[permission]?.View;

  try {
    if (!Component || !hasPermission || (condition && !condition(profile)))
      return <NoPermissionTable />;

    return (
      <div className="table-container dashboard-container-shadow">
        <Component
          permission={privileges[permission]?.View}
          emailPermission={privileges[emailPermission]?.View}
          platformPermission={privileges[platformPermission]?.View}
          currentUser={profile}
          {...extraProps}
        />
      </div>
    );
  } catch (err) {
    FixRolePrivileges().then(
      (result) => {
        console.log("Role Privileges Updated", result);
        window.location.reload(false);
      },
      (error) => {
        console.log(error);
      }
    );
    return <div className="table-container"></div>;
  }
};

AdminMainTable.propTypes = {
  currentTab: PropTypes.string.isRequired,
  currentSubTab: PropTypes.string,
};

export default AdminMainTable;
